<template>
  <Promised v-if="!tournament.externalLink" :promise="request">
    <!-- Use the "pending" slot to display a loading message -->
    <template v-slot:pending>
			<shark-loader />
    </template>
    <!-- The default scoped slot will be used as the result -->
    <template v-slot="{data}">
			<slot :registrations="data" :registrationType="registrationType"/>
    </template>
    <!-- The "rejected" scoped slot will be used if there is an error -->
    <template v-slot:rejected="error">
      <p>Error: {{ error.detail || error }}</p>
    </template>
  </Promised>
</template>

<script>
	import { Promised } from 'vue-promised';

	export default {
		name: "RegistrationsRunner",
		components: {
			Promised
		},
		computed: {
			request() {
				const url = `${this.$apiRoot}/tournaments/${this.tournament.id}/registrations/`;
				return this.axios.get(url);
			},
			registrationType() {
				return this.tournament.individualRegistration ? "individual" : "team";
			}
		},
		props: {
			tournament: {
				type: Object,
				required: true
			},
		},
	}
</script>